import { Button, Theme } from '@routific/hive';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export interface Action {
  id: string;
  label?: string;
  onClick: () => void;
  disabled?: boolean;
}

export interface Props {
  cancel: Action;
  confirm: Action
}

const Container = styled.div`
  display: flex;
  gap: ${Theme.Spacing.mdSpacing};
  justify-content: flex-end;
`;

const ConfirmAction: React.FC<Props> = ({ cancel, confirm }) => {
  const { t } = useTranslation('common');

  return (
    <Container>
      <Button key={cancel.id} data-testid={cancel.id} onClick={cancel.onClick} size='middle'>{cancel.label || t('cancel')}</Button>
      <Button key={confirm.id} data-testid={confirm.id} onClick={confirm.onClick} size='middle' type='primary' disabled={confirm.disabled} >{confirm.label || t('confirm')}</Button>
    </Container>
  );
};

export default ConfirmAction;
